import { render, staticRenderFns } from "./ViewAuthRegistration.vue?vue&type=template&id=2a4d05e4&"
import script from "./ViewAuthRegistration.vue?vue&type=script&lang=js&"
export * from "./ViewAuthRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports